import React, { useContext } from 'react';

export const MetaDataContext = React.createContext({
  componentRequest: {},
  viewType: null,
});

export const useMetaDataContext = () => useContext(MetaDataContext);
